import qs from 'qs';
import client from './client';

export default {
  async generateGLAReport(id, selfGla, params) {
    const prefix = selfGla ? 'sla' : 'gla';
    const response = await client.get(`${prefix}/${id}${qs.stringify(params, { addQueryPrefix: true })}`);
    return response.data;
  },
};
